import TagManager from "react-gtm-module";
import { User } from "../../lib/auth";
import { envConfig } from "../../config";
import { isNullOrUndefOrEmpty } from "@civicscience/chops";

/**
 * Declare GTM's `dataLayer` property for use within this file.
 * This, combined with the declare below, makes this available within the scope of this file.
 *
 * https://github.com/vercel/next.js/discussions/20784#discussioncomment-4101864
 */
type WindowWithDataLayer = Window & {
  dataLayer: Record<string, unknown>[];
};

declare const window: WindowWithDataLayer;

export const initialize = () => {
  return envConfig.gtmId && TagManager.initialize({ gtmId: envConfig.gtmId });
};

/**
 * Pushes `data` to the GTM data layer if GTM has been initilized.
 */
export const pushToDataLayer = (data: Record<string, unknown>) => {
  !isNullOrUndefOrEmpty(data) &&
    window.dataLayer &&
    window.dataLayer.push(data);
};

/**
 * Pushes the provided `User` to the GTM data layer.
 */
export const pushUserToDataLayer = (user: User): void => {
  pushToDataLayer({
    userId: user.userId,
    accountId: user.accountRefid,
    isImpersonated: user.isImpersonated,
    isSysAdmin: user.isSysAdmin,
    isInternal: user.isInternal,
  });
};
